import courses from '../js/courses'

const getCurrentClassId = (student, classes) => {
  return student.classes
    .filter(classId => !classes[classId].done)
    .sort((a, b) => classes[a].ordinal - classes[b].ordinal)[0]
}

const flattenAndSort = (arr) => {
  return arr.map(el => el.split(', ')).flat().sort()
}

export default {
  install: function (Vue) {
    Vue.prototype.$student = function (student, classes) {
      // Note: any invocation of $student needs to have the class list passed in with it
      return {
        get currentClass () {
          const currentClassId = getCurrentClassId(student, classes)
          return currentClassId ? classes[currentClassId] : {}
        },
        get currentCourse () {
          const currentClassId = getCurrentClassId(student, classes)
          const currentCourse = currentClassId ? courses[classes[currentClassId].course_id] : {}
          return currentCourse
        },
        get allCourses () {
          const allCourses = student.classes
            .filter(classId => !classes[classId].done)
            .map(classId => courses[classes[classId].course_id])
          return [...new Set(allCourses)]
        },
        get enrolledDates() {
          let datesByCourse = {}
          let keys = ['details','day','time']
          // create an object with all courses and enrolled class dates/times
          student.classes.forEach(classId => {
            const classDetails = classes[classId]
            if (!datesByCourse[classDetails.course_id]) {
              datesByCourse[classDetails.course_id] = {}
              keys.forEach(key => datesByCourse[classDetails.course_id][key] = [])
            }
            keys.forEach(key => {
              if (!classDetails.done) datesByCourse[classDetails.course_id][key].push(classDetails[key])
            })
          })
          // remove duplicates
          Object.keys(datesByCourse).forEach(course => {
            keys.forEach(key => datesByCourse[course][key] = [...new Set(datesByCourse[course][key])])
            datesByCourse[course]['details'] = flattenAndSort(datesByCourse[course]['details'])
            
          })
          console.log(datesByCourse)
          return datesByCourse
        }
      }
    }
  },
}